import { format, formatDistanceToNow } from 'date-fns'

$(document).ready(function () {
  if ($('body').is('.listings-show, .listings-feed_show')) {
    var $slider = $('.listing-slider')

    if ($slider.length > 0) {
      $slider.on('unslider.ready', function () {
        $slider.css('visibility', 'visible')
        if ($('.unslider-carousel li').length < 2) {
          $('.unslider-arrow').hide()
        }
      })

      $slider.on('unslider.change', function (_event, index) {
        $slider.css('visibility', 'visible')
        $('video').each(function (_, value) {
          $(value).get(0).pause()
        })
        $('.current_photo_number').html(parseInt(index) + 1)
      })

      $slider.unslider()

      $('.unslider-nav-thumbnail').click(function () {
        var id = $(this).attr('id')
        $('.unslider-nav')
          .find("[data-slide='" + id + "']")
          .click()
      })

      var hammertime = new Hammer($slider.get(0))

      hammertime.on('swipeleft', function () {
        $('.unslider .next').click()
      })

      hammertime.on('swiperight', function () {
        $('.unslider .prev').click()
      })
    }

    // Humanise dates in admin box

    const createdAtValue = $('.created_at').data('date')
    const updatedDateValue = $('.updated_at').data('date')

    if (createdAtValue && updatedDateValue) {
      var createdDate = new Date(createdAtValue)
      $('.created_at').html(formatDistanceToNow(createdDate) + ' ago (' + format(createdDate, 'dd MMM yyyy') + ')')

      var updatedDate = new Date(updatedDateValue)
      $('.updated_at').html(formatDistanceToNow(updatedDate) + ' ago (' + format(updatedDate, 'dd MMM yyyy') + ')')
    }
  }

  // Sticky to show on scroll
  $(document).scroll(function () {
    if ($(document).scrollTop() >= 50) {
      $('.sticky_ad').css('visibility', 'visible')
    }
    if ($(document).scrollTop() < 50) {
      $('.sticky_ad').css('visibility', 'hidden')
    }
  })

  // Show phone number when enquiry button is clicked
  $('.show-number').click(function (e) {
    e.preventDefault()
    var num = $('.pet-listing__phone-number').first().text()
    $('.show-number').html(num)
    $('.show-number').attr('href', 'tel:' + num)
  })
})
